var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46967 5.78033C5.76256 6.07322 6.23744 6.07322 6.53033 5.78033L11.0303 1.28033C11.3232 0.987437 11.3232 0.512563 11.0303 0.21967C10.7374 -0.0732236 10.2626 -0.0732236 9.96967 0.21967L6 4.18934L2.03033 0.21967C1.73744 -0.0732236 1.26256 -0.0732236 0.969669 0.21967C0.676776 0.512563 0.676776 0.987437 0.969669 1.28033L5.46967 5.78033Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMenu);
export default __webpack_public_path__ + "static/media/arrow_menu.83e3adb97818c8848d24012b7693b005.svg";
export { ForwardRef as ReactComponent };